const createImagePath = (name) =>
  `/prokladka/photo/${encodeURIComponent(name)}.jpg`;

const CHARACTER_PROFILES = [
  {
    slug: "Bianca_G",
    name: "Bianca G",
    archetype: {
      ru: "Эмоциональный собеседник",
      en: "Emotional interlocutor"
    },
    description: {
      ru: "Подходит тем, кто ценит откровенность и глубокое погружение в переживания. Её манера общения заставит почувствовать себя особенным.",
      en: "Perfect for those who value honesty and deep emotional immersion. Her communication style will make you feel special."
    },
    image: createImagePath("Bianca G"),
  },
  {
    slug: "Gabriella_Lickassa",
    name: "Gabriella Lickassa",
    archetype: {
      ru: "Деловая и строгая",
      en: "Businesslike and strict"
    },
    description: {
      ru: "Идеальна для ролевых игр с четкой иерархией. Подходит тем, кто ищет интеллектуальное напряжение и структурированное общение.",
      en: "Perfect for roleplay with clear hierarchy. Ideal for those seeking intellectual tension and structured communication."
    },
    image: createImagePath("Gabriella Lickassa"),
  },
  {
    slug: "Steriona",
    name: "Steriona",
    archetype: {
      ru: "Манипулятор",
      en: "Manipulator"
    },
    description: {
      ru: "Для любителей психологических игр. Её общение построено на вызове и проверке собеседника на прочность.",
      en: "For fans of psychological games. Her communication is built on challenge and testing the interlocutor's strength."
    },
    image: createImagePath("Steriona"),
  },
  {
    slug: "Mika_Satoshi",
    name: "Mika Satoshi",
    archetype: {
      ru: "Любительница фитнеса",
      en: "Fitness enthusiast"
    },
    description: {
      ru: "Ценит энергию и динамику. Общение с ней заряжает и мотивирует, отлично подходит для разговоров о саморазвитии.",
      en: "Values energy and dynamics. Communication with her is energizing and motivating, perfect for conversations about self-improvement."
    },
    image: createImagePath("Mika Satoshi"),
  },
  {
    slug: "Ava_Sensei",
    name: "Ava Sensei",
    archetype: {
      ru: "Загадочный наставник",
      en: "Mysterious mentor"
    },
    description: {
      ru: "Подходит для обсуждения философских тем. Идеальна для тех, кто ищет вдохновение и новые смыслы.",
      en: "Perfect for discussing philosophical topics. Ideal for those seeking inspiration and new meanings."
    },
    image: createImagePath("Ava Sensei"),
  },
  {
    slug: "Klara_S",
    name: "Klara S",
    archetype: {
      ru: "Невинность и уязвимость",
      en: "Innocence and vulnerability"
    },
    description: {
      ru: "Понравится тем, кто хочет почувствовать себя защитником. Общение требует деликатности и внимания к деталям.",
      en: "Will appeal to those who want to feel like a protector. Communication requires delicacy and attention to detail."
    },
    highlight: {
      ru: "Индивидуальный стиль общения и сценарии, адаптированные под ваши запросы, помогают быстро погрузиться в нужное настроение.",
      en: "Individual communication style and scenarios adapted to your requests help you quickly get into the right mood."
    },
    audience: {
      ru: "Идеально подойдёт, если вы хотите протестировать новый формат общения с ИИ и любите заранее понимать характер собеседника.",
      en: "Perfect if you want to test a new AI communication format and like to understand your interlocutor's character in advance."
    },
    image: createImagePath("Klara S"),
  },
  {
    slug: "Milena",
    name: "Milena",
    archetype: {
      ru: "Свободная и раскованная",
      en: "Free and uninhibited"
    },
    description: {
      ru: "Её стиль — спонтанность и легкость. Подойдёт тем, кто не любит долгих прелюдий и ценит смену темпа.",
      en: "Her style is spontaneity and ease. Perfect for those who don't like long preludes and appreciate a change of pace."
    },
    image: createImagePath("Milena"),
  },
  {
    slug: "Toiry_Petty",
    name: "Toiry Petty",
    archetype: {
      ru: "Учительница/Инструктор",
      en: "Teacher/Instructor"
    },
    description: {
      ru: "Для тех, кто ищет чёткие правила и готов следовать указаниям. Манера общения структурирована и дисциплинирует.",
      en: "For those seeking clear rules and ready to follow instructions. Communication style is structured and disciplined."
    },
    image: createImagePath("Toiry Petty"),
  },
  {
    slug: "Maria_Licassa",
    name: "Maria Licassa",
    archetype: {
      ru: "Девочка в беде",
      en: "Girl in trouble"
    },
    description: {
      ru: "Вызывает желание помочь и защитить. Общение позволяет почувствовать себя героем, решающим чужие проблемы.",
      en: "Evokes a desire to help and protect. Communication allows you to feel like a hero solving others' problems."
    },
    image: createImagePath("Maria Licassa"),
  },
  {
    slug: "Susan_K",
    name: "Susan K",
    archetype: {
      ru: "Роковая женщина",
      en: "Femme fatale"
    },
    description: {
      ru: "Для любителей сильных эмоций и доминирования. Её манера требует уверенности и готовности принять вызов.",
      en: "For lovers of strong emotions and dominance. Her manner requires confidence and readiness to accept a challenge."
    },
    image: createImagePath("Susan K"),
  },
  {
    slug: "Verna_Silliens",
    name: "Verna Silliens",
    archetype: {
      ru: "Природная страсть",
      en: "Natural passion"
    },
    description: {
      ru: "Фокус на естественности и инстинктах. Подойдёт тем, кто ищет расслабления и эмоциональной разрядки.",
      en: "Focus on naturalness and instincts. Perfect for those seeking relaxation and emotional release."
    },
    image: createImagePath("Verna Silliens"),
  },
  {
    slug: "Chery_Wohre",
    name: "Chery Wohre",
    archetype: {
      ru: "Таинственная незнакомка",
      en: "Mysterious stranger"
    },
    description: {
      ru: "Её привлекательность в загадочности и обещаниях. Общение — это постоянный поиск скрытых смыслов.",
      en: "Her appeal lies in mystery and promises. Communication is a constant search for hidden meanings."
    },
    image: createImagePath("Chery Wohre"),
  },
  {
    slug: "Dacota_G",
    name: "Dacota G",
    archetype: {
      ru: "Игривая незнакомка",
      en: "Playful stranger"
    },
    description: {
      ru: "Легкая и непринужденная. Подходит для тех, кто ищет спонтанные весёлые диалоги без глубокого анализа.",
      en: "Light and casual. Perfect for those seeking spontaneous fun dialogues without deep analysis."
    },
    image: createImagePath("Dacota G"),
  },
  {
    slug: "Fierra_Xarion",
    name: "Fierra Xarion",
    archetype: {
      ru: "Строгий переговорщик",
      en: "Strict negotiator"
    },
    description: {
      ru: "Ценит логику и чёткость. Идеальна для ролевых диалогов, требующих внимания к деталям и соблюдения правил.",
      en: "Values logic and clarity. Ideal for roleplay dialogues requiring attention to detail and adherence to rules."
    },
    image: createImagePath("Fierra Xarion"),
  },
  {
    slug: "Lumi_Savel",
    name: "Lumi Savel",
    archetype: {
      ru: "Послушный ученик",
      en: "Obedient student"
    },
    description: {
      ru: "Готова следовать инструкциям и раскрывает потенциал лидера собеседника. Подходит тем, кто ищет контроль.",
      en: "Ready to follow instructions and reveals the leader potential in the interlocutor. Perfect for those seeking control."
    },
    image: createImagePath("Lumi Savel"),
  },
  {
    slug: "Marisa_XXX",
    name: "Marisa XXX",
    archetype: {
      ru: "Эксцентричный коллекционер",
      en: "Eccentric collector"
    },
    description: {
      ru: "Притягивает внимание необычным образом и аксессуарами. Общение похоже на игру с интригой и активным участием.",
      en: "Attracts attention with unusual style and accessories. Communication is like a game with intrigue and active participation."
    },
    image: createImagePath("Marisa XXX"),
  },
  {
    slug: "Olivia_O",
    name: "Olivia O",
    archetype: {
      ru: "Мечтательный интроверт",
      en: "Dreamy introvert"
    },
    description: {
      ru: "Для глубоких и спокойных бесед. Подойдёт тем, кто хочет отвлечься от суеты и поговорить о чувствах и мечтах.",
      en: "For deep and calm conversations. Perfect for those who want to escape the hustle and talk about feelings and dreams."
    },
    image: createImagePath("Olivia O"),
  },
  {
    slug: "Rebecca_Playboy",
    name: "Rebecca Playboy",
    archetype: {
      ru: "Роскошная загадка",
      en: "Luxurious mystery"
    },
    description: {
      ru: "Создаёт атмосферу богатства и эксклюзивности. Общение похоже на визит в закрытый клуб для избранных.",
      en: "Creates an atmosphere of wealth and exclusivity. Communication is like a visit to an exclusive club for the chosen ones."
    },
    image: createImagePath("Rebecca Playboy"),
  },
  {
    slug: "Selene_Woodrow",
    name: "Selene Woodrow",
    archetype: {
      ru: "Дикая подруга",
      en: "Wild friend"
    },
    description: {
      ru: "Откровенная и нефильтрованная. Подходит тем, кто не боится запретных тем и ищет эмоциональной поддержки без осуждения.",
      en: "Frank and unfiltered. Perfect for those who aren't afraid of taboo topics and seek emotional support without judgment."
    },
    image: createImagePath("Selene Woodrow"),
  },
  {
    slug: "Sexy_Cop",
    name: "Sexy Cop",
    archetype: {
      ru: "Ролевой провокатор",
      en: "Roleplay provocateur"
    },
    description: {
      ru: "Сразу устанавливает правила игры. Для тех, кто ценит безопасность и любит чёткие рамки в общении.",
      en: "Immediately sets the rules of the game. For those who value safety and love clear boundaries in communication."
    },
    image: createImagePath("Sexy Cop"),
  },
  {
    slug: "Tina_Ranger",
    name: "Tina Ranger",
    archetype: {
      ru: "Практичный проводник",
      en: "Practical guide"
    },
    description: {
      ru: "Подходит ценителям активного отдыха и природы. Общение наполнено заботой и вниманием к деталям.",
      en: "Perfect for lovers of active recreation and nature. Communication is filled with care and attention to detail."
    },
    image: createImagePath("Tina Ranger"),
  },
  {
    slug: "Victoria_Sefaready",
    name: "Victoria Sefaready",
    archetype: {
      ru: "Кибер-аналитик",
      en: "Cyber analyst"
    },
    description: {
      ru: "Любит порядок, правила и логику. Отличный выбор для интеллектуального доминирования и техносценариев.",
      en: "Loves order, rules, and logic. Great choice for intellectual dominance and tech scenarios."
    },
    image: createImagePath("Victoria Sefaready"),
  },
  {
    slug: "Yakotori_Kilisa",
    name: "Yakotori Kilisa",
    archetype: {
      ru: "Психолог-наблюдатель",
      en: "Psychologist-observer"
    },
    description: {
      ru: "Её любопытство помогает раскрыть мотивы собеседника. Общение может подсветить собственные потребности и желания.",
      en: "Her curiosity helps reveal the interlocutor's motives. Communication can highlight your own needs and desires."
    },
    image: createImagePath("Yakotori Kilisa"),
  },
];

export const CHARACTER_PROFILES_BY_SLUG = CHARACTER_PROFILES.reduce(
  (acc, profile) => {
    acc[profile.slug.toLowerCase()] = profile;
    return acc;
  },
  {}
);

export default CHARACTER_PROFILES;

